import { render, staticRenderFns } from "./LoadoutFilter.vue?vue&type=template&id=3812cfd4"
import script from "./LoadoutFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadoutFilter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports